import * as Sentry from '@sentry/browser';

export function handleError(error) {
  if (error.message) {
    alert(error.message);
  } else {
    alert(error);
  }
  console.error(error);
  
  if (import.meta.env.VITE_SENTRY_DSN) {
    Sentry.captureException(error);
  }
}
